const handleScrollURL = () => {
  const sections = document.querySelectorAll('.scrollable-section');
  let currentSectionId = '';
  sections.forEach((section) => {
    const rect = section.getBoundingClientRect();
    if (rect.top >= -100 && rect.top <= 100) {
      currentSectionId = section.id;
    }
  });
  if (currentSectionId) {
    const currentUrl = window.location.href;
    const newUrl = currentUrl.includes('#')
      ? currentUrl.replace(/#.*$/, '#' + currentSectionId)
      : currentUrl + '#' + currentSectionId;
    window.history.replaceState(null, null, newUrl);
  }
};

export const throttle = (func, limit) => {
  let inThrottle;
  return () => {
    if (!inThrottle) {
      func();
      inThrottle = true;
      setTimeout(() => (inThrottle = false), limit);
    }
  };
};

export const optimizedHandleScroll = throttle(handleScrollURL, 50);

export const isTextFieldActive = () => {
  const el = document.activeElement;
  if (!el) return false;
  const tag = el.tagName;
  if (['INPUT', 'TEXTAREA', 'SELECT'].includes(tag)) return true;
  if (el.isContentEditable) return true;
  if (el.closest?.('.ant-select-focused')) return true;
  if (el.closest?.('.ant-picker-focused')) return true;
  return false;
};
